import { 
  useContext, 
  useEffect, 
  useState 
} from "react"

import { ContextualSidebarContext } from "@context";
import { Button } from "@heroui/react"
import { ChevronLeftIcon } from "@heroicons/react/24/outline"
import MenuItems from "../MenuItems"

import { 
  GuardianImportIssueReport, 
  LastImportReport, 
  MetaDetails
} from "../Sections"

import { VIEWS } from "../data"
import PropTypes from "prop-types"

const MenuRouter = ({ clientId, initialView = "MENU" }) => {
  const [view, setView] = useState(VIEWS[initialView])
  const { setContextualSidebar } = useContext(ContextualSidebarContext);

  useEffect(() => {
    setContextualSidebar(prev => ({ ...prev, title: view.title, subTitle: view.subTitle }));
  }, [view, setContextualSidebar]);

  const backButton = (
    <Button className="mt-2" onPress={() => setView(VIEWS.MENU)} fullWidth>
      <ChevronLeftIcon className="w-4 h-4 mr-2" />
      Back to Menu
    </Button>
  )

  return (
    <div>
      {view.key === "MENU" && <MenuItems handleMenuSelect={setView} />}
      {view.key === "GUARDIAN_IMPORT_ISSUE_REPORT" && <GuardianImportIssueReport backButton={backButton} clientId={clientId} />}
      {view.key === "LAST_IMPORT_REPORT" && <LastImportReport backButton={backButton} clientId={clientId} />}
      {view.key === "META" && <MetaDetails backButton={backButton} clientId={clientId} />}
    </div>
  )
}

MenuRouter.propTypes = {
  clientId: PropTypes.string.isRequired,
  initialView: PropTypes.string,
}

export default MenuRouter